import type { PipelineRun } from "@/hooks/useProjectPipelines";

/**
 * Counts pending gates for a pipeline run. A gate is pending when its
 * phase status is "gate" and there is no entry in `metadata.gate_decisions`
 * for that phase id (D3 of RAISE-16619 design).
 *
 * This allows the run-list badge (AC4) with zero extra requests.
 */
export function pendingGateCount(run: PipelineRun): number {
  const decisions =
    (run.metadata?.gate_decisions as Record<string, unknown> | undefined | null) ?? {};
  return run.phases.filter(
    (p) => p.status === "gate" && !(p.id in decisions),
  ).length;
}
